export default __webpack_public_path__ + "static/media/iosQrCode.164ebf0b.png";